export default __webpack_public_path__ + "static/nest-banner-87b642ad075d4db87405abd9df6b1d8a.png";